import { getProbableGardenerResources } from "../helper";
import { ConfirmBoxType } from "../../reducer/type";

type GardenerResourceWarningProps = Pick<
  ConfirmBoxType,
  "entity" | "operation" | "resources"
>;

const GardenerResourceWarning = ({
  resources,
  entity,
}: GardenerResourceWarningProps) => {
  const possibleResources = getProbableGardenerResources(resources, entity);

  if (!possibleResources) {
    return null;
  }

  let middleClause = "";

  if (possibleResources > 1) {
    middleClause = `${possibleResources} of the related resources are`;
  } else {
    if (!Array.isArray(resources) || resources.length === 1) {
      middleClause = "this resource is";
    } else {
      middleClause = `${possibleResources} of the selected resources is`;
    }
  }

  return (
    <p className="color-red margin-top-20 margin-bottom-20">
      It looks like {middleClause} used by Gardener. Deleting or modifying such
      resources outside of Gardener may affect the stability of the shoot
      cluster.
    </p>
  );
};

export default GardenerResourceWarning;
